import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { User } from './user';
const json = require("json!./../../../../resources/properties.json");

@Injectable()
export class ProfileService {

    private _profileUrl = '/profileData';
    private serverURL: string;

    constructor(private http: Http) {
        this.serverURL = json.api_url;
    }

    getProfile() {
        var token = localStorage.getItem('token');
        var authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }

        let options = new RequestOptions({ headers: authHeader, body: "" });

        return this.http.get(this.serverURL + this._profileUrl, options)
            .toPromise()
            .then(res => { return JSON.parse(res.text()) }, this.handleError);
    }

    editProfile(profile: User): Promise<any> {

        console.log("editing profile"); console.log(profile);
        console.log("petition " + this._profileUrl + "/" + profile.id);

        var token = localStorage.getItem('token');
        var authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });

        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }

        return this.http.put(this.serverURL + this._profileUrl, this.serializeObj(profile), { headers: authHeader }).toPromise().then(res => {
            console.log("USER RESULT:");
            console.log(res);
            return res;
        });

    }

    editProfileInfo(profile: User, city_id: Number) {

        var token = localStorage.getItem('token');
        var authHeader = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }

        var url = `${this._profileUrl}/${city_id}`;

        return this.http.put(this.serverURL + url, this.serializeObj(profile), { headers: authHeader }).toPromise().then(res => {
            if(JSON.parse(res.text()).code == 1) {
                localStorage.setItem('userName', JSON.parse(res.text()).user_name);
            }
        });

    }

    sendEmail() {
        var token = localStorage.getItem('token');
        var authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        authHeader.append('Authorization', 'Bearer ' + token);
        let options = new RequestOptions({ headers: authHeader, body: "" });
        return this.http.get(this.serverURL + '/emailData/sendEmailProfile', options)
            .toPromise()
            .then(res => {
                if (JSON.parse(res.text()).code == -1) {
                    return JSON.parse(res.text()).active != 2;
                }
                else {
                    return false;
                }
            });
    }

    verifyPassword(password: String) {

        var token = localStorage.getItem('token');
        var authHeader = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }

        return this.http.post(this.serverURL + this._profileUrl, this.serializeObj({ "password": password }), { headers: authHeader }).toPromise().then(result => {

            return JSON.parse(result.text()).isMatch;

        }).catch(this.handleError);

    }

    changePassword(password: String): Promise<String> {

        var token = localStorage.getItem('token');
        var authHeader = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }

        return this.http.put(this.serverURL + this._profileUrl, this.serializeObj({ "password": password }), { headers: authHeader }).toPromise().then(result => {

            return JSON.parse(result.text()).code;

        }).catch(this.handleError);

    }

    changeCategory(cat: number) {
        console.log(cat);
        var token = localStorage.getItem('token');
        var authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        authHeader.append('Authorization', 'Bearer ' + token);
        return this.http.post(this.serverURL + '/elementData/changeCategory', this.serializeObj({ "category": cat }), {
            headers: authHeader
        }).map((res: any) => {
            let data = res.json();
            return data.subrole;
        });
    }

    changeEmail(email: String): Promise<String> {

        var token = localStorage.getItem('token');
        var authHeader = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }

        var url = `${this._profileUrl}/${"email"}`;
        console.log(url);

        return this.http.put(this.serverURL + url, this.serializeObj({ "email": email }), { headers: authHeader }).toPromise().then(result => {

            return JSON.parse(result.text()).code;

        }).catch(this.handleError);
    }

    existsEmail(email: string) {
        return this.http.get(this.serverURL + '/usersData/existsEmail/' + email).toPromise()
            .then(res => {
                if (JSON.parse(res.text()).code == 1) {
                    return true;
                }
                else {
                    return false;
                }
            }, this.handleError);
    }

    createTransaction(accountType: number, method: number) {
        var token = localStorage.getItem('token');
        var authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        authHeader.append('Authorization', 'Bearer ' + token);
        return this.http.post(this.serverURL + '/transactions/createTransaction', this.serializeObj({ "accountType": accountType, "method": method }), {
            headers: authHeader
        })
            .toPromise()
            .then(res => {
                if (JSON.parse(res.text()).code == 1) {
                    return JSON.parse(res.text());
                }
                else {
                    return JSON.parse(res.text());
                }
            });
    }

    updateTransaction(id: number, method: number) {
        var token = localStorage.getItem('token');
        var authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        authHeader.append('Authorization', 'Bearer ' + token);
        return this.http.post(this.serverURL + '/transactions/updateTransaction', this.serializeObj({ "method": method, "id": id }), {
            headers: authHeader
        })
            .toPromise()
            .then(res => {
                if (JSON.parse(res.text()).code == 1) {
                    return JSON.parse(res.text());
                }
                else {
                    return JSON.parse(res.text());
                }
            });
    }

    registerFree() {
        var token = localStorage.getItem('token');
        var authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        authHeader.append('Authorization', 'Bearer ' + token);
        return this.http.post(this.serverURL + '/transactions/registerFree', {}, {
            headers: authHeader
        })
            .map((res: any) => {
                let data = res.json();
                return data.code;
            });
    }

    changeLanguage(lang: string) {
        console.log(lang);
        var language: number = 0;
        if (lang == "CATALAN") {
            language = 1;
        } else if (lang == "SPANISH") {
            language = 2;
        }

        var token = localStorage.getItem('token');
        var authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        authHeader.append('Authorization', 'Bearer ' + token);
        return this.http.post(this.serverURL + this._profileUrl + "/language", this.serializeObj({ "language": language }), { headers: authHeader }).map((res: any) => {
            let data = res.json();
            return data;
        });
    }

    getUserLanguage() {

        let token = localStorage.getItem('token');
        let authHeader = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

        if (token != null && token != "") {

            authHeader.append('Authorization', 'Bearer ' + token);
            let options = new RequestOptions({ headers: authHeader, body: "" });

            return this.http.get(this.serverURL + "/mainData" + "/language", options).toPromise().then(res => {

                if (JSON.parse(res.text()).code == 1) {
                    return JSON.parse(res.text()).language;
                }

            }).catch(this.handleError);

        }

    }

    private handleError(error: any) {
        // In a real world app, we might use a remote logging infrastructure
        // We'd also dig deeper into the error to get a better message
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error(errMsg); // log to console instead
        return Promise.reject(errMsg);
    }

    private serializeObj(obj: any) {
        var result: any[] = [];

        for (var property in obj)
            result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));

        return result.join("&");
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/super_user/profile/profile.service.ts
 **/